import * as React from 'react';
import { ChevronDown, ChevronUp, ChevronsUpDown, EyeOff, X } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'shadcn/components/dropdown-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'shadcn/components/tooltip';
import { Info } from 'lucide-react';

import { cn } from 'helpers/css';
import NewDesign from 'components/NewDesign';
import { TooltipReactTooltip } from 'components/Tooltip';

export default function DataGridColumnHeader({ column, title, className, tooltip, ...props }) {
  console.log('123123123123', !column.getCanSort() && !column.getCanHide());
  if (!column.getCanSort() && !column.getCanHide()) {
    return (
      <div
        className={cn(
          'tw-text-foreground tw-font-semibold [&_svg]:tw-size-4 [&_svg]:tw-shrink-0 [&_svg]:tw-text-muted-foreground',
          className
        )}
      >
        {title}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'tw--ml-1.5 tw-flex tw-h-8 tw-items-center tw-gap-1.5 tw-rounded-md tw-px-2 tw-py-1.5 hover:tw-bg-accent focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-ring data-[state=open]:tw-bg-accent [&_svg]:tw-size-4 [&_svg]:tw-shrink-0 [&_svg]:tw-text-muted-foreground tw-text-foreground tw-font-semibold tw-text-left',
          className
        )}
        {...props}
      >
        {tooltip ? (
          <>
            {title}
            <NewDesign.Tooltip message={tooltip} />
          </>
        ) : (
          title
        )}
        {column.getCanSort() &&
          (column.getIsSorted() === 'desc' ? (
            <ChevronDown />
          ) : column.getIsSorted() === 'asc' ? (
            <ChevronUp />
          ) : (
            <ChevronsUpDown />
          ))}
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' className='tw-w-28'>
        {column.getCanSort() && (
          <>
            <DropdownMenuCheckboxItem
              className='tw-relative tw-pr-8 tw-pl-2 [&>span:first-child]:tw-right-2 [&>span:first-child]:tw-left-auto [&_svg]:tw-text-muted-foreground tw-gap-2'
              checked={column.getIsSorted() === 'asc'}
              onClick={() => column.toggleSorting(false)}
            >
              <ChevronUp size={16} />
              Asc
            </DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem
              className='tw-relative tw-pr-8 tw-pl-2 [&>span:first-child]:tw-right-2 [&>span:first-child]:tw-left-auto [&_svg]:tw-text-muted-foreground tw-gap-2'
              checked={column.getIsSorted() === 'desc'}
              onClick={() => column.toggleSorting(true)}
            >
              <ChevronDown size={16} />
              Desc
            </DropdownMenuCheckboxItem>
            {column.getIsSorted() && (
              <DropdownMenuItem
                className='tw-pl-2 [&_svg]:tw-text-muted-foreground'
                onClick={() => column.clearSorting()}
              >
                <X size={16} />
                Reset
              </DropdownMenuItem>
            )}
          </>
        )}
        {column.getCanHide() && (
          <DropdownMenuCheckboxItem
            className='tw-relative tw-pr-8 tw-pl-2 [&>span:first-child]:tw-right-2 [&>span:first-child]:tw-left-auto [&_svg]:tw-text-muted-foreground tw-gap-2'
            checked={!column.getIsVisible()}
            onClick={() => column.toggleVisibility(false)}
          >
            <EyeOff size={16} />
            Hide
          </DropdownMenuCheckboxItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
